/**
 * StationModeInfoTip — Wraps the Station Mode button to show a tooltip on hover.
 */

import { useState, useRef } from 'react';

const STATION_TOOLTIP = [
    'Station Mode provides a full-screen view that displays only alerts for',
    'devices that have not yet been cleared. It is designed for use on dedicated',
    'nurse stations and wall-mounted view boards.',
];

const StationModeInfoTip = ({ children }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const [style, setStyle] = useState({});

    const handleEnter = () => {
        if (!ref.current) return;
        const rect = ref.current.getBoundingClientRect();
        const spaceRight = window.innerWidth - rect.left;
        const spaceBelow = window.innerHeight - rect.bottom;

        setStyle({
            position: 'fixed',
            left: spaceRight < 320 ? undefined : `${rect.left}px`,
            right: spaceRight < 320 ? '16px' : undefined,
            top: spaceBelow < 80 ? undefined : `${rect.bottom + 6}px`,
            bottom: spaceBelow < 80 ? `${window.innerHeight - rect.top + 6}px` : undefined,
            maxWidth: '300px',
            whiteSpace: 'normal',
        });
        setOpen(true);
    };

    return (
        <span ref={ref} onMouseEnter={handleEnter} onMouseLeave={() => setOpen(false)} style={{ position: 'relative' }}>
            {children}
            {open && (
                <span className="na-type-popover" style={style}>
                    <span style={{ fontSize: 'var(--font-size-xs)', color: 'var(--color-text-muted)', fontWeight: 'var(--font-weight-semibold)' }}>About Station Mode</span>
                    <span style={{ fontSize: 'var(--font-size-xs)', color: 'var(--color-text-body)', lineHeight: '1.45' }}>{STATION_TOOLTIP.join(' ')}</span>
                </span>
            )}
        </span>
    );
};

export default StationModeInfoTip;
